/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  LetterbookSettingType,
} from "features/Letterbooks/types";
import { Link, usePage } from "@inertiajs/react";
import Icon from "hardcover-ui/components/Icon";
import classNames from "lib/classNames";
import generateUrl from "features/Letterbooks/utils/generateUrl";
import LetterbooksViewType from "types/LetterbooksViewType";

export function ViewLink({
  view,
  title,
  icon,
  settings,
}: {
  view: LetterbooksViewType;
  title: string;
  icon: any;
  settings: LetterbookSettingType;
}) {
  const active = settings.view === view;
  return (
    <Link
      href={generateUrl({ settings, overrides: { view } })}
      data-tooltip-id="tooltip"
      data-tooltip-content={`${title} View`}
      className={classNames(
        "px-2 py-1 rounded-md space-x-2 font-semibold",
        active
          ? "text-indigo-900 dark:text-yellow-900 bg-indigo-200 dark:bg-yellow-500"
          : "text-gray-600 bg-gray-200 dark:text-gray-50 dark:bg-gray-900 hover:bg-indigo-300 dark:hover:bg-yellow-500 hover:text-indigo-900 dark:hover:text-yellow-900"
      )}
    >
      <Icon icon={icon} size="lg" />
      {active ? <span className="hidden lg:inline">{title}</span> : false}
    </Link>
  );
}
